import type { FC } from 'react';

import Url from '../../../../components/fields/url/url';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['linkLabel'] as const;

const Field = formField(Url, {
  defaultValue: [],
  transformProps: (props) => pickProps(props, componentProps),
});

export type UrlFieldWrapperProps = FieldWrapperProps<typeof Field>;

const UrlFieldWrapper: FC<UrlFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default UrlFieldWrapper;
